export const newExternalUrl = (pathname: string) =>
  new URL(
    `${window.location.protocol}//${window.location.host}${pathname}`,
  ).toString();
